import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';

/**
 * Displays a reusable appointment summary card showing a title, a count, and optional styling and image.
 * @component
 * @selector app-appointments-cards
 * @example
 *   <app-appointments-cards
 *     [title]="'Upcoming Appointments'"
 *     [count]="'5'"
 *     [cardClass]="'highlight'"
 *     [image]="'/assets/appointment.png'">
 *   </app-appointments-cards>
 * @input {string} title - The heading text for the card (e.g., "Upcoming Appointments").
 * @input {string} count - A short numeric or textual indicator shown prominently on the card (e.g., "5").
 * @input {string} cardClass - Optional CSS class name(s) to apply custom styles to the card container.
 * @input {string} image - Optional image URL to display alongside the card content.
 * @output none - This component does not emit any output events.
 * Notes:
 * - The component is standalone and relies on its template and stylesheet for presentation.
 * - No custom methods or lifecycle hooks are defined on this component; it is a presentational/stateless component that renders based on inputs.
 */
@Component({
  selector: 'app-appointments-cards',
  standalone: true,
  imports: [NgClass],
  templateUrl: './appointments-cards.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './appointments-cards.component.scss',
})
export class AppointmentsCardsComponent {
  @Input() title = '';
  @Input() count = '';
  @Input() cardClass = '';
  @Input() image = '';
}
